<template>
  <div class="footer-section">
    <div class="footer-content">
      <div class="footer-top">
        <div class="footer-logo">
          <img src="@/assets/images/logo.png" class="b_logo"/>
          <div class="company-name">{{ this.$i18n.messages[this.$i18n.locale].foot.s1 }}</div>
        </div>
        <div class="footer-links">
          <router-link
            to="/product"
          ><span>{{ this.$i18n.messages[this.$i18n.locale].foot.s2 }}</span>
          </router-link>
          <router-link
            to="/about"
          ><span>{{ this.$i18n.messages[this.$i18n.locale].foot.s3 }}</span>
          </router-link>
          <router-link
            to="/support"
          ><span>{{ this.$i18n.messages[this.$i18n.locale].foot.s4 }}</span>
          </router-link>
          <router-link
            to="/contact"
          ><span>{{ this.$i18n.messages[this.$i18n.locale].foot.s5 }}</span>
          </router-link>
        </div>
      </div>
      <div class="b_line"></div>
      <div class="footer-info">
        <p class="f_one" v-html="this.$i18n.messages[this.$i18n.locale].foot.s6"></p>
        <p class="f_two" v-html="this.$i18n.messages[this.$i18n.locale].foot.s7"></p>
        <p class="f_three"><a href="https://beian.miit.gov.cn" target="_blank">备案号: 粤ICP备2022078556号</a></p>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  name: 'ButtomBar',
  components: {},
  data() {
    return {};
  },
  methods: {},
  computed: {}
};
</script>

<style lang="less">
.b_logo {
  width: 50px;
  height: 43px;
}

.footer-section {
  background-color: #e8f0fe;
  height: 250px;
  display: flex;
  justify-content: center;
  font-family: Arial, sans-serif;
}

.footer-content {
  max-width: 1200px;
  width: 100%;
  margin-bottom: 30px;
}

.footer-top {
  display: flex;
  height: 50%;
  align-items: center;
}

.footer-logo {
  margin-left: 50px;
  display: flex;
  align-items: center;
}

.footer-logo img {
  height: 50px;
  margin-right: 10px;
}

.company-name {
  height: 32px;
  font-weight: normal;
  font-size: 22px;
  color: #006CB9;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.b_line {
  height: 1px;
  background: #09244D;
  border: 1px solid #09244D;
  opacity: 0.15;
}

.footer-links {
  margin-left: auto;
  margin-right: 115px;
  height: 50%;
  display: flex;
  gap: 20px;
  align-items: center;
}

.footer-links a {
  font-size: 16px;
  color: #005DE8;
  text-decoration: none;
}

.footer-links a:hover {
  text-decoration: underline;
}

.footer-info {
  margin-top: 20px;
  font-size: 14px;
  color: #333;
  text-align: center;
  justify-content: center;
}

.f_one {
  height: 20px;
  font-family: Arial, sans-serif;
  font-weight: normal;
  font-size: 18px;
  color: #244476;
  line-height: 30px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  justify-content: center;
}

.f_two {
  height: 20px;
  font-family: Arial, sans-serif;
  font-weight: normal;
  font-size: 18px;
  color: #244476;
  line-height: 30px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}

.f_three {
  height: 20px;
  font-family: Arial, sans-serif;
  font-weight: normal;
  font-size: 18px;
  color: #244476;
  line-height: 30px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}
</style>




// WEBPACK FOOTER //
// src/layouts/HeaderLayout/components/ButtomBar.vue